<template>
	<m-main-layout>
		<el-form :model="form" :rules="rules" label-width="120px" ref="form">
			<el-form-item label="状态">
				<el-tag type="warning" v-if="form.state === 0">待审核</el-tag>
				<el-tag type="success" v-if="form.state === 1">已通过</el-tag>
				<el-tag type="danger" v-if="form.state === 2">已拒绝</el-tag>
			</el-form-item>
			<el-form-item label="身份">
				<template v-if="form.user_type === 'hz'">货主</template>
				<template v-if="form.user_type === 'gys'">供应商</template>
			</el-form-item>
			<el-form-item label="供应商类型" prop="gys_type"  v-if="form.user_type === 'gys'" :rules="form.user_type === 'gys' ? [{required: true,message:'供应商类型必选'}] : null">
				<el-radio-group v-model="form.gys_type">
					<el-radio label="wuliu">物流供应商</el-radio>
					<el-radio label="shebei">设备供应商</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="公司名称" prop="company">
				<el-input v-model="form.company" style="width: 500px;" maxlength="50" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="公司logo" prop="logo">
				<head-img-upload v-model="form.logo"></head-img-upload>
<!--				<el-input v-model="form.logo" style="width: 500px;" maxlength="50" show-word-limit></el-input>-->
			</el-form-item>
			<el-form-item label="联系人" prop="contact">
				<el-input v-model="form.contact" style="width: 500px;" maxlength="50" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="联系电话" prop="phone">
				<el-input v-model="form.phone" style="width: 500px;" maxlength="50" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="职位" prop="job">
				<el-input v-model="form.job" style="width: 500px;" maxlength="50" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="优势产品" prop="type_superiority_ids" v-if="form.user_type === 'gys' && form.gys_type === 'shebei'">
				<type-select multiple :can-add="false" v-model="form.type_superiority_ids" url="/Type/listAll" :data="{akey:'superiority'}" style="width: 500px;" key="type_superiority_ids"></type-select>
			</el-form-item>
			<el-form-item label="办公区域" prop="bangong_city_code">
				<province-select v-model="bangong_area" @change="changeProvince"></province-select>
<!--				<type-select multiple :can-add="false" v-model="form.type_industry_ids" url="/Type/listAll" :data="{akey:'industry'}" style="width: 500px;" key="type_industry_ids"></type-select>-->
			</el-form-item>
			<el-form-item label="行业类型" prop="type_industry_ids">
				<type-select multiple :can-add="false" v-model="form.type_industry_ids" url="/Type/listAll" :data="{akey:'industry'}" style="width: 500px;" key="type_industry_ids"></type-select>
			</el-form-item>
			<el-form-item label="服务类型" prop="type_fuwu_ids" :rules="[{required:true,message:'服务类型必选'}]" v-if="form.user_type === 'gys'">
				<type-select multiple :can-add="false" v-model="form.type_fuwu_ids" url="/Type/listAll" :data="{akey:'fuwu'}" style="width: 500px;" key="type_fuwu_ids"></type-select>
			</el-form-item>
			<el-form-item label="区域" prop="province_codes">
				<type-select multiple :can-add="false" v-model="form.province_codes" url="/Area/listAll" :data="{pid:['1','<='],orderBy:'code',sortBy:'asc'}" list-label="name" list-value="code" style="width: 500px;" key="province_codes"></type-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm">确定</el-button>
				<el-button type="" @click="$router.back()">返回</el-button>
			</el-form-item>
		</el-form>
	</m-main-layout>
</template>

<script>
import {CodeToText} from 'element-china-area-data'

export default {
	name: "edit",
	data() {
		return {
			bangong_area:[],
			form:{
				id:'',
				company:'',
				logo:'',
				province_codes:[],
				type_industry_ids:[],
				type_fuwu_ids:[],
				type_superiority_ids:[],
				bangong_city_code:'',
				bangong_city_name:'',
				bangong_province_code:'',
				bangong_province_name:'',
				contact:'',
				phone:'',
				job:'',
				user_type:'',
				gys_type:'',
				uid:'',
				state:'',
				reset_file:0
			},
			gys_type:'',
			showTips:false,
			rules:{
				company:[{required:true,message:'公司名称必填'}],
				logo:[{required:true,message:'公司名称必填'}],
				province_codes:[{required:true,message:'区域必选'}],
				type_industry_ids:[{required:true,message:'行业类型必选'}],
				contact:[{required:true,message:'联系人必填'}],
				phone:[{required:true,message:'联系方式必填'},{pattern:this.$regexp.mobile,message: '请填写正确的手机号'}],
				job:[{required:true,message:'职位必填'}],
				// bangong_city_code:[{required:true,message:'办公区域必选'}]
			}
		}
	},
	created() {
		this.form.id = this.$route.query.id ? this.$route.query.id : '';
		if(this.form.id){
			this.getDetail();
		}
	},
	mounted() {
	},
	methods: {
		changeProvince(e){
			// console.log(e);
			this.form.bangong_province_code = e[0];
			this.form.bangong_province_name = CodeToText[e[0]];
			this.form.bangong_city_code = e[1];
			this.form.bangong_city_name = CodeToText[e[1]];
		},
		submitForm(){
			let _this = this;
			this.showTips = false;
			this.form.reset_file = 0;
			
			this.$refs['form'].validate((valid) => {
				if (valid) {
					if(_this.gys_type !== _this.form.gys_type) {
						_this.form.reset_file = 1;
						for(let i=0;i < _this.form.zizhi_files.length;i++){
							if(_this.form.zizhi_files[i].file){
								_this.showTips = true;
							}
						}
						
						for(let i=0;i < _this.form.pinggu_files.length;i++){
							if(_this.form.pinggu_files[i].file){
								_this.showTips = true;
							}
						}
						
						for(let i=0;i < _this.form.rongyu_files.length;i++){
							if(_this.form.rongyu_files[i].file){
								_this.showTips = true;
							}
						}
						
						for(let i=0;i < _this.form.sanfang_files.length;i++){
							if(_this.form.sanfang_files[i].file){
								_this.showTips = true;
							}
						}
						
						if(_this.showTips){
							_this.$confirm('修改供应商类型，会清空原有的所有资质, 是否继续?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								delete _this.form.zizhi_files;
								delete _this.form.rongyu_files;
								delete _this.form.sanfang_files;
								delete _this.form.pinggu_files;
								
								_this.$http.httpPost({
									url: '/UserCompany/edit',
									datas: _this.form,
									success(res) {
										_this.$message.success('操作成功');
										_this.$router.back();
									}
								})
							}).catch(() => {
							});
						}else{
							delete _this.form.zizhi_files;
							delete _this.form.rongyu_files;
							delete _this.form.sanfang_files;
							delete _this.form.pinggu_files;
							
							_this.$http.httpPost({
								url: '/UserCompany/edit',
								datas: _this.form,
								success(res) {
									_this.$message.success('操作成功');
									_this.$router.back();
								}
							})
						}
					}else{
						delete _this.form.zizhi_files;
						delete _this.form.rongyu_files;
						delete _this.form.sanfang_files;
						delete _this.form.pinggu_files;
						
						_this.$http.httpPost({
							url: '/UserCompany/edit',
							datas: _this.form,
							success(res) {
								_this.$message.success('操作成功');
								_this.$router.back();
							}
						})
					}
				}
			});
		},
		getDetail(){
			let _this = this;
			this.$http.httpPost({
				url:'/UserCompany/detail',
				datas:{id:this.form.id},
				success(res){
					console.log(res);
					_this.form.state = res.state;
					_this.form.uid = res.uid;
					_this.form.company = res.company;
					_this.form.contact = res.contact;
					_this.form.phone = res.phone;
					_this.form.job = res.job;
					_this.form.logo = res.logo;
					_this.form.type_fuwu_ids = res.type_fuwu_ids;
					_this.form.type_industry_ids = res.type_industry_ids;
					_this.form.type_superiority_ids = res.type_superiority_ids;
					_this.form.bangong_city_code = res.bangong_city_code;
					_this.form.bangong_city_name = res.bangong_city_name;
					_this.form.bangong_province_code = res.bangong_province_code;
					_this.form.bangong_province_name = res.bangong_province_name;
					_this.form.province_codes = res.province_codes;
					_this.form.user_type = res.user_type;
					_this.form.gys_type = res.gys_type;
					_this.gys_type = res.gys_type;
					_this.bangong_area = [res.bangong_province_code ? res.bangong_province_code : '',res.bangong_city_code ? res.bangong_city_code : ''];
					
					_this.form.zizhi_files = res.zizhi_files;
					_this.form.rongyu_files = res.rongyu_files;
					_this.form.sanfang_files = res.sanfang_files;
					_this.form.pinggu_files = res.pinggu_files;
				}
			})
		}
	}
}
</script>
